import { useState } from "react";
import { styles } from "../../../utils/styles/products-green-finance-styles";
import { colors } from "../../../utils/const";
import { useI18n } from "@/i18n/I18nProvider";
import Box from "@mui/material/Box";
import dynamic from "next/dynamic";

import CalcPopup from "@/components/products-revamp/CalcPopup";
import StepsRow from "@/components/steps-row";
import DynamicFAQSection from "@/components/DynamicFAQSection";
import ProductMain from "@/components/products-revamp/product-main";
import ApplyProduct from "@/components/products-revamp/product-apply";
import ListSection from "@/components/products-revamp/list-section";
import Features from "@/components/products-revamp/features-section";
import {
  getLocalizedValue,
  getStaticTextByKey,
} from "@/utils/general-functions";
import { emptyProps, getProductPageData } from "@/services/get-product-data";
import { useProductLoanPackages } from "@/hooks/useProductLoanPackages";
import { getProductsText } from "../../../../locales/products";
const PageHead = dynamic(() => import("@/components/PageHead"));

export default function Index({
  heroData,
  contentWithImageData,
  faqData,
  stepsData,
  modelsData,
  plansData,
  whycontactData,
  staticTextData,
  featuresData,
  mainData,
  accordionData,
}) {
  const { t, locale } = useI18n();
  const products = getProductsText(locale);
  const { targetProduct, data } = useProductLoanPackages(products.green_finance.id);
  const [openCalc, setOpenCalc] = useState(false);

  const staticTexts = getStaticTextByKey(staticTextData?.data);

  return (
    <>
      <PageHead
        title={getLocalizedValue(mainData[0], "meta_title", locale)}
        description={getLocalizedValue(mainData[0], "meta_description", locale)}
        scripts={getLocalizedValue(mainData[0], "schema", locale)}
      />
      <Box sx={styles.container}>
        {heroData?.length > 0 && (
          <ProductMain
            heroData={heroData}
            staticTexts={staticTexts}
            onApplyClick={() => {
              const formSection = document.getElementById("apply-form");
              if (formSection) {
                formSection.scrollIntoView({ behavior: "smooth" });
              }
            }}
            onCalcClick={() => setOpenCalc((prev) => !prev)}
            onExploreMoreClick={() => {
              const formSection = document.getElementById(
                "green-financing-features",
              );
              if (formSection) {
                formSection.scrollIntoView({ behavior: "smooth" });
              }
            }}
            imgStyle={{
              mt: { xs: 5, xl: 10 },
              transform: {
                lg:
                  locale == "ar"
                    ? "translateX(0%) scaleX(-1)"
                    : "translateX(0%) scaleX(1)",
              },
            }}
            headerH1={true}
          />
        )}
        {accordionData?.length > 0 &&
          accordionData.map((section, index) => (
            <ListSection
              key={section?.id || index}
              img={section?.img}
              altImg={section?.alt}
              title={section?.title?.text[locale]}
              titleType={section?.title?.type}
              list={section?.items}
            />
          ))}

        <Box sx={{ position: "relative", bgcolor: colors.white }}>
          {featuresData?.length > 0 &&
            featuresData.map((section, index) => (
              <Features
                key={section?.id || index}
                section={section}
                bgHeight={{
                  xs: "70%",
                  md: locale === "en" ? "50%" : "40%",
                  lg: locale === "en" ? "46%" : "42%",
                }}
                id="green-financing-features"
              />
            ))}

          {/**faq section */}
          {faqData?.length > 0 &&
            faqData.map((section, index) => (
              <DynamicFAQSection
                key={section?.id || index}
                title={staticTexts.faqs_section_title.value.text[locale] || ""}
                items={section?.faqs}
                renderHTML={true}
                variantTitle="h2"
                variantQ="h2"
              />
            ))}
        </Box>

        {/**steps section */}
        {stepsData?.length > 0 &&
          stepsData.map((section, index) => (
            <StepsRow
              key={section.id || index}
              title={section?.title?.text?.[locale]}
              titleType={section?.title?.type}
              subtitle={section?.description?.text?.[locale]}
              subtitleType={section?.description?.type}
              steps={section?.items}
            />
          ))}

        <ApplyProduct
          img={heroData[0]?.img}
          title={mainData[0]?.form_title.text[locale]}
          titleType={mainData[0]?.form_title?.type}
          description={mainData[0]?.form_desc.text[locale]}
          descType={mainData[0]?.form_desc?.type}
          formType="b"
          product="greenFinance"
          source={35}
        />
        {targetProduct?.hasPlan && (
          <CalcPopup
            open={openCalc}
            onClose={() => setOpenCalc(false)}
            data={data}
            max_amount={targetProduct?.maxLimit}
            price_label={products.green_finance.price}
            price_desc={products.green_finance.price_desc}
          />
        )}
      </Box>
    </>
  );
}
export async function getServerSideProps() {
  try {
    const data = await getProductPageData("green finance");
    return { props: data };
  } catch {
    return { props: emptyProps };
  }
}
